import { getPostbackMessage } from './getPostbackMessage'

export const getMessagesFromHistory = (history) => {
  return history
    .map(event => {
      let message = Object.assign({}, event.message)
      message.isFromBot = !!event.isFromBot
      message.status = event.status
      if (message.type === 'postback') {
        message = getPostbackMessage(message)
      }
      message.action = event.action
      return message
    })
    .reverse()
}
